import { useEffect, useState } from "react";
import { getAccountContributionsAsync } from "./../../../../../services/contributionService";
import { getCurrencyAmount } from "./../../../../../utils/stringUtils";
import Pagination from "../../../../../components/common/Pagination";
import Table from "../../../../../components/common/Table";
import moment from "moment";

const ContributionsTable = ({
  id,
  columns,
  data,
  setData,
  tableOptions,
  onChange,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchContributions = async () => {
      setIsLoading(true);

      const response = await getAccountContributionsAsync(id, tableOptions);
      const { result, page, total_count } = response;

      const contributions = result.map((item) => {
        const amount = getCurrencyAmount(item.amount);

        item["amount"] = <span>&#8369; {amount}</span>;
        item["transaction_id"] = item.transaction_id ?? "-";
        item["period"] = moment(item.period).format("MMM yyyy");
        item["date_contributed"] = moment(item.date_contributed).format("LL");

        return item;
      });

      if (mounted) {
        setData(contributions);
        setCurrentPage(page);
        setTotalCount(total_count);
        setIsLoading(false);
      }
    };

    fetchContributions();

    return () => {
      mounted = false;
    };
  }, [id, tableOptions, setData]);

  const handleSort = (sort_column) => {
    const options = { ...tableOptions };
    options.sort_column = sort_column;
    onChange(options);
  };

  const handlePageChange = (page) => {
    const options = { ...tableOptions };
    options.current_page = page;
    onChange(options);
  };

  return (
    <div className="overflow-auto lg:overflow-visible">
      <Table
        data={data}
        columns={columns}
        sortColumn={tableOptions.sort_column}
        onSort={handleSort}
        isLoading={isLoading}
      />
      <Pagination
        itemsCount={totalCount}
        currentPage={currentPage}
        pageSize={tableOptions.page_size}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default ContributionsTable;
